import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../common/services/translation.service';

@Component({
    selector: 'cpq-setup-not-found',
    templateUrl: './cpq-not-found.component.html',
    standalone: false
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
